module.exports = __webpack_public_path__ + "img/inspectionServices.d3efe03a.svg";